import React from 'react';

const Hero = () => {
  return (
    <section 
      id="home"
      className="bg-white overflow-hidden"
      style={{ paddingTop: '120px', paddingBottom: '60px' }} 
    >
      <div className="container">
        <div className="row align-items-center">
          
          {/* Text Content - Left Side */}
          <div className="col-lg-6 text-center text-lg-start pe-lg-5 mb-5 mb-lg-0">
            
            {/* Clean Badge */}
            <div className="d-inline-flex align-items-center bg-light border px-3 py-2 rounded-pill mb-4 shadow-sm">
              <span className="badge rounded-pill me-2" style={{ backgroundColor: '#0284c7' }}>Registered</span>
              <span className="text-secondary small fw-medium">Charitable & Religious Trust Act</span>
            </div>
            
            {/* Main Headline */}
            <h1 className="display-4 fw-bold mb-4" style={{ color: '#1e293b', lineHeight: '1.2' }}>
              Transforming Lives <br/> Through <span style={{ color: '#0284c7' }}>Education & Skill.</span>
            </h1>
            
            {/* Sub-headline */}
            <p className="lead mb-4 text-muted" style={{ fontSize: '1.15rem' }}>
              Jairaji Educational Trust is committed to empowering rural communities with industry-relevant skills, making them self-reliant and building a brighter future for their families.
            </p>
            
            {/* Action Buttons */}
            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start mb-5">
              <a href="#about" className="btn px-4 py-3 fw-bold rounded shadow-sm transition-all" style={{ backgroundColor: '#0284c7', color: 'white' }}>
                Discover Our Mission
              </a>
              <a href="#details" className="btn btn-outline-secondary px-4 py-3 fw-bold rounded transition-all">
                Organization Details
              </a>
            </div>

            {/* Quick Stats */}
            <div className="d-flex gap-4 justify-content-center justify-content-lg-start border-top pt-4">
              <div>
                <h3 className="fw-bold mb-0" style={{ color: '#0284c7' }}>100%</h3>
                <small className="text-muted text-uppercase fw-medium" style={{ fontSize: '0.8rem' }}>Commitment</small>
              </div>
              <div className="vr text-secondary"></div>
              <div>
                <h3 className="fw-bold mb-0" style={{ color: '#0284c7' }}>Pan-UP</h3>
                <small className="text-muted text-uppercase fw-medium" style={{ fontSize: '0.8rem' }}>Reach</small>
              </div>
              <div className="vr text-secondary"></div>
              <div>
                <h3 className="fw-bold mb-0" style={{ color: '#0284c7' }}>7+</h3>
                <small className="text-muted text-uppercase fw-medium" style={{ fontSize: '0.8rem' }}>Sectors</small>
              </div>
            </div>
          </div>

          {/* Image Content - Right Side */}
          <div className="col-lg-6">
            <div className="ps-lg-4">
              {/* Modern & Professional Skill Training Image */}
              <img 
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop" 
                alt="Students and Professionals Learning" 
                className="img-fluid rounded-4 shadow-lg w-100"
                style={{ objectFit: 'cover', height: '520px' }}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;